
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setOrderValueType = (orderValueType: libTypes.Order['orderValueType']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.orderValueType = fns.order.set.orderValueType(orderValueType);
        })
    });
};